import { Box, Grid, Paper, Tabs, Tab } from "@mui/material";
import React, { useState, useEffect } from "react";
import { NavLink, Outlet, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const tabStyle = {
  textTransform: "capitalize",
  fontWeight: "bold",
  borderRadius: "10px",
};

const LaboratoryNav = () => {
  const { t } = useTranslation();
  const [value, setValue] = useState("/laboratory");
  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = (event, newValue) => {
    setValue(newValue);
    navigate(newValue);
  };

  useEffect(() => {
    const path = location.pathname;
    const validPaths = [
      "/laboratory",
      "/laboratory/test-category",
      "/laboratory/test-types",
      "/laboratory/patient-test",
      "/laboratory/surgery-patient-test",
      "/laboratory/test-sample",
    ];

    if (validPaths.includes(path)) {
      setValue(path);
    } else {
      setValue("/laboratory");
    }
  }, [location.pathname]);

  return (
    <Grid container maxWidth="xl">
      <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
        <Paper sx={{ padding: "10px 0px", boxShadow: "0px 0px 0px" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{
              ml: "5px",
              "& .MuiTabs-indicator": { display: "none" },
              "& .MuiTab-root": { minWidth: "120px" },
            }}
          >
            <Tab
              style={{
                ...tabStyle,
                backgroundColor: value === "/laboratory" ? "#007174" : "white",
                color: value === "/laboratory" ? "white" : "black",
              }}
              label={t("laboratory.dashboard")}
              value="/laboratory"
              component={NavLink}
              to="/laboratory"
            />
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/laboratory/test-category" ? "#007174" : "white",
                color:
                  value === "/laboratory/test-category" ? "white" : "black",
              }}
              label={t("laboratory.testCategory")}
              value="/laboratory/test-category"
              component={NavLink}
              to="/laboratory/test-category"
            />
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/laboratory/test-types" ? "#007174" : "white",
                color: value === "/laboratory/test-types" ? "white" : "black",
              }}
              label={t("laboratory.testType")}
              value="/laboratory/test-types"
              component={NavLink}
              to="/laboratory/test-types"
            />
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/laboratory/patient-test" ? "#007174" : "white",
                color: value === "/laboratory/patient-test" ? "white" : "black",
              }}
              label={t("laboratory.patientTest")}
              value="/laboratory/patient-test"
              component={NavLink}
              to="/laboratory/patient-test"
            />

            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/laboratory/surgery-patient-test"
                    ? "#007174"
                    : "white",
                color:
                  value === "/laboratory/surgery-patient-test"
                    ? "white"
                    : "black",
              }}
              label={t("laboratory.surgeryPatientTest")}
              value="/laboratory/surgery-patient-test"
              component={NavLink}
              to="/laboratory/surgery-patient-test"
            />
            {/* <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/laboratory/test-sample" ? "#007174" : "white",
                color: value === "/laboratory/test-sample" ? "white" : "black",
              }}
              label={t("laboratory.testSample")}
              value="/laboratory/test-sample"
              component={NavLink}
              to="/laboratory/test-sample"
            /> */}
          </Tabs>
        </Paper>
      </Box>
      <Outlet />
    </Grid>
  );
};

export default LaboratoryNav;
